import React from 'react';
import { Button, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import GoogleIcon from './GoogleIcon';

const StyledGoogleButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: '48px',
  borderRadius: '4px',
  border: '1px solid #CCCCCC',
  backgroundColor: '#FFFFFF',
  color: '#303030',
  fontFamily: 'PolySans, "Helvetica Neue", Arial, sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  textTransform: 'none',
  padding: '12px 16px',
  justifyContent: 'center',
  transition: 'all 0.2s ease',
  '&:hover': {
    backgroundColor: '#F8F8F8',
    border: '1px solid #999999',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)'
  },
  [theme.breakpoints.down('sm')]: {
    height: '44px',
    fontSize: '15px'
  }
}));

const GoogleButton = ({ onClick, ...props }) => {
  return (
    <StyledGoogleButton onClick={onClick} {...props}>
      <Stack direction="row" spacing={0.75} alignItems="center">
        <GoogleIcon width={18} height={18} />
        <span>Continue with Google</span>
      </Stack>
    </StyledGoogleButton>
  );
};

export default GoogleButton;